import { Navigate, useLocation } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthProvider";

const UserRoute = ({ element }) => {
  const location=useLocation()
  const { user, loading } = useContext(AuthContext);  
  if(!loading){
  if (!user) {
    sessionStorage.setItem("redirectPath", location.pathname)
    return <Navigate to="/login" />;
  }
  return element; // Render the component if user is logged in
}
  
};

export default UserRoute;
